import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import PropTypes from "prop-types";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import { transparentize, useEuiTheme } from '../../../../../src/services';
import { getPropsFromComponent } from '../../../services/props/get_props';
import { useEuiBackgroundColorCSS, EuiCode, EuiColorPickerSwatch, EuiText, useEuiBackgroundColor, useEuiPaddingSize, BACKGROUND_COLORS, euiBackgroundColor, useEuiPaddingCSS, EuiButtonGroup, EuiDescribedFormGroup, EuiPanel, EuiSpacer, logicalCSS } from '../../../../../src';
import { EuiThemeColors } from '../_props';
import { ThemeExample } from '../_components/_theme_example';
import { brand_colors, brand_text_colors, shade_colors, special_colors, text_colors } from '../../../../../src/themes/amsterdam/global_styling/variables/_colors';
import { ThemeValuesTable } from '../_components/_theme_values_table';
export var brandKeys = Object.keys(brand_colors);
export var BrandJS = function BrandJS(_ref) {
  var description = _ref.description;

  var _useEuiTheme = useEuiTheme(),
      euiTheme = _useEuiTheme.euiTheme;

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.colors[brand]"),
    description: description,
    example: ___EmotionJSX("div", {
      css: /*#__PURE__*/css("padding:", euiTheme.size.s, ";color:", euiTheme.colors.ink, ";background:", euiTheme.colors.warning, ";;label:BrandJS;")
    }, ___EmotionJSX("strong", null, "background: ", euiTheme.colors.warning)),
    snippet: 'background: ${euiTheme.colors.warning};',
    snippetLanguage: "emotion"
  }));
};
BrandJS.propTypes = {
  description: PropTypes.node
};
export var BrandValuesJS = function BrandValuesJS() {
  var _useEuiTheme2 = useEuiTheme(),
      euiTheme = _useEuiTheme2.euiTheme;

  var props = getPropsFromComponent(EuiThemeColors);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: brandKeys.map(function (color) {
      return {
        id: color,
        token: "colors.".concat(color),
        type: props[color],
        // @ts-ignore TODO
        value: euiTheme.colors[color]
      };
    }),
    render: function render(item) {
      return ___EmotionJSX(EuiColorPickerSwatch, {
        color: item.value,
        disabled: true
      });
    }
  }));
};
export var brandTextKeys = Object.keys(brand_text_colors);
export var textKeys = Object.keys(text_colors);
export var TextJS = function TextJS(_ref2) {
  var description = _ref2.description;

  var _useEuiTheme3 = useEuiTheme(),
      euiTheme = _useEuiTheme3.euiTheme;

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.colors[colorText]"),
    description: ___EmotionJSX(React.Fragment, null, description, ___EmotionJSX("p", null, "If your background color is anything other than or darker than the", ' ', ___EmotionJSX(EuiCode, null, "body"), " color, you will want to re-calculate the high contrast version by using the", ' ', ___EmotionJSX(Link, {
      to: "/theming/colors/utilities"
    }, ___EmotionJSX(EuiCode, null, "makeHighContrastColor(foreground)(background)")), ' ', "method.")),
    example: ___EmotionJSX("div", {
      css: /*#__PURE__*/css("color:", euiTheme.colors.warningText, ";;label:TextJS;")
    }, ___EmotionJSX("strong", null, "color: ", euiTheme.colors.warningText)),
    snippet: 'color: ${euiTheme.colors.warningText};',
    snippetLanguage: "emotion"
  }));
};
TextJS.propTypes = {
  description: PropTypes.node
};
export var TextValuesJS = function TextValuesJS() {
  var _useEuiTheme4 = useEuiTheme(),
      euiTheme = _useEuiTheme4.euiTheme;

  var props = getPropsFromComponent(EuiThemeColors);
  var textColors = textKeys.concat(brandTextKeys);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: textColors.map(function (color) {
      return {
        id: color,
        token: "colors.".concat(color),
        type: props[color],
        // @ts-ignore TODO
        value: euiTheme.colors[color]
      };
    }),
    render: function render(item) {
      return ___EmotionJSX("div", {
        css: /*#__PURE__*/css("color:", item.value, ";", logicalCSS('min-width', euiTheme.size.l), " ", logicalCSS('min-height', euiTheme.size.l), ";;label:TextValuesJS;")
      }, ___EmotionJSX("strong", null, "Aa"));
    }
  }));
};
export var shadeKeys = Object.keys(shade_colors);
export var ShadeJS = function ShadeJS(_ref3) {
  var description = _ref3.description;

  var _useEuiTheme5 = useEuiTheme(),
      euiTheme = _useEuiTheme5.euiTheme;

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeExample, {
    title: ___EmotionJSX("code", null, "euiTheme.colors[colorShade]"),
    description: description,
    example: ___EmotionJSX("div", {
      css: /*#__PURE__*/css("padding:", euiTheme.size.s, ";background:", transparentize(euiTheme.colors.mediumShade, 0.25), ";;label:ShadeJS;")
    }, ___EmotionJSX("strong", null, "background: ", transparentize(euiTheme.colors.mediumShade, 0.25))),
    snippet: 'background: ${transparentize(euiTheme.colors.mediumShade, .25)};',
    snippetLanguage: "emotion"
  }));
};
ShadeJS.propTypes = {
  description: PropTypes.node
};
export var ShadeValuesJS = function ShadeValuesJS() {
  var _useEuiTheme6 = useEuiTheme(),
      euiTheme = _useEuiTheme6.euiTheme;

  var props = getPropsFromComponent(EuiThemeColors);
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ThemeValuesTable, {
    items: shadeKeys.map(function (color) {
      return {
        id: color,
        token: "colors.".concat(color),
        type: props[color],
        // @ts-ignore TODO
        value: euiTheme.colors[color]
      };
    }),
    render: function render(item) {
      return ___EmotionJSX(EuiColorPickerSwatch, {
        color: item.value,
        disabled: true
      });
    }
  }));
};
var specialKeys = Object.keys(special_colors);
export var SpecialJS = ({
  description
}) => {
  const {
    euiTheme
  } = useEuiTheme();
  return <>
      <ThemeExample title={<code>euiTheme.colors[special]</code>} description={description} example={<div css={/*#__PURE__*/css("padding:", euiTheme.size.s, ";color:", euiTheme.colors.ghost, ";background-color:", euiTheme.colors.ink, ";;label:SpecialJS;")}>
            <strong>
              This text is always white and the background always black.
            </strong>
          </div>} snippet={`color: \${euiTheme.colors.ghost};
  background-color: \${euiTheme.colors.ink};`} snippetLanguage="emotion" />
    </>;
};
SpecialJS.propTypes = {
  description: PropTypes.node
};
export const SpecialValuesJS = () => {
  const {
    euiTheme
  } = useEuiTheme();
  const props = getPropsFromComponent(EuiThemeColors);
  const allSpecialKeys = specialKeys.concat(['ghost', 'ink']);
  return <>
      <ThemeValuesTable items={allSpecialKeys.map(color => {
      return {
        id: color,
        token: `colors.${color}`,
        type: props[color],
        // @ts-ignore TODO
        value: euiTheme.colors[color]
      };
    })} render={item => <EuiColorPickerSwatch color={item.value} disabled />} />
    </>;
};
export const UtilsJS = () => {
  return <>
      <EuiText grow={false}>
        <p>
          To all but ensure proper contrast of text to background, we recommend
          using our pre-defined shades of background colors based on the{' '}
          <strong>EuiTheme</strong> brand colors. You can also use{' '}
          <Link to="/layout/panel">
            <strong>EuiPanel</strong>
          </Link>{' '}
          for the same effect plus more options like padding and rounded
          corners.
        </p>
      </EuiText>

      <ThemeExample title={<code>{'useEuiBackgroundColorCSS()[color]'}</code>} type="style hook" props={`color: '${BACKGROUND_COLORS.join("' | '")}';`} description={<>
            <p>
              Returns an object of the available color keys containing the css
              string of the computed background version for the given{' '}
              <EuiCode language="sass">color</EuiCode>.
            </p>
            <p>
              This is best used to map component prop styles to padding output.
            </p>
          </>} example={<p css={[useEuiBackgroundColorCSS().accent, useEuiPaddingCSS().l]}>
            <code>background-color: {useEuiBackgroundColor('accent')}</code>
          </p>} snippetLanguage="tsx" snippet={`const colorStyles = useEuiBackgroundColorCSS();
const cssStyles = [colorStyles['accent']];

<span css={cssStyles}>
  /* Your content */
</span>`} />

      <ThemeExample title={<code>useEuiBackgroundColor(color, method?)</code>} type="hook" props={`color: '${BACKGROUND_COLORS.join("' | '")}';

method? 'opaque' | 'transparent';`} description={<p>
            Returns just the computed background color for the given{' '}
            <EuiCode language="sass">color</EuiCode>.
          </p>} example={<p css={/*#__PURE__*/css("background:", useEuiBackgroundColor('subdued'), ";padding:", useEuiPaddingSize('l'), ";;label:UtilsJS;")}>
            <code>{useEuiBackgroundColor('subdued')}</code>
          </p>} snippetLanguage="emotion" snippet={"background: ${useEuiBackgroundColor('subdued')};"} />
    </>;
};
export const UtilsValuesJS = () => {
  const euiTheme = useEuiTheme();
  const backgroundButtons = ['opaque', 'transparent'].map(m => {
    return {
      id: m,
      label: m
    };
  });
  const [backgroundSelected, setBackgroundSelected] = useState(backgroundButtons[0].id);
  return <>
      <EuiPanel color="accent">
        <EuiDescribedFormGroup fullWidth title={<h3>Different colors for different contexts</h3>} description={<p>
              While the hook accepts rendering the value as opaque or
              transparent, we highly suggest reserving transparent for use only
              during interactive states like hover and focus.
            </p>}>
          <EuiSpacer />
          <EuiButtonGroup buttonSize="m" legend="Value measurement to show in table" options={backgroundButtons} idSelected={backgroundSelected} onChange={id => setBackgroundSelected(id)} color="accent" isFullWidth />
        </EuiDescribedFormGroup>
      </EuiPanel>
      <EuiSpacer />

      <ThemeValuesTable items={BACKGROUND_COLORS.map(color => {
      return {
        id: color,
        token: backgroundSelected === 'transparent' ? `useEuiBackgroundColor('${color}', 'transparent')` : `useEuiBackgroundColor('${color}')`,
        value: euiBackgroundColor(euiTheme, color, {
          method: backgroundSelected
        })
      };
    })} render={item => <EuiColorPickerSwatch color={item.value} style={{
      background: item.value
    }} disabled />} />
    </>;
};

try {
  BrandJS.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/color/_color_js.tsx',
    description: '',
    displayName: 'BrandJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}

try {
  TextJS.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/color/_color_js.tsx',
    description: '',
    displayName: 'TextJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}

try {
  ShadeJS.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/color/_color_js.tsx',
    description: '',
    displayName: 'ShadeJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}

try {
  SpecialJS.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/color/_color_js.tsx',
    description: '',
    displayName: 'SpecialJS',
    methods: [],
    props: {
      description: {
        defaultValue: null,
        description: '',
        name: 'description',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/_props.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'React.ReactNode'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}